import { render, staticRenderFns } from "./DepartmentUpdate.vue?vue&type=template&id=b9973fba&"
import script from "./DepartmentUpdate.vue?vue&type=script&lang=js&"
export * from "./DepartmentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports